// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"0":"css/promo","2449":"css/home","6663":"css/core","7676":"css/firstLoad"}[chunkId] || chunkId) + "_077.css";
};